import React, {Fragment, useEffect, useState} from "react";
import {Chart, Interval, Tooltip, Line, GComponents} from 'bizcharts';
import {connect} from "react-redux";
import Spinner from "../../common/Spinner";

import 'bootstrap/dist/css/bootstrap.min.css';
import {CardGroup, Carousel} from "react-bootstrap";
import SingleSlidePlot from "./SingleSlidePLot";
import Card from "react-bootstrap/Card";
import {DataView} from "@antv/data-set";

const {
    Canvas,
} = GComponents;

const PlotCarousel = ({PlotData: {plot_data, loading, hide_data, active_plot, refresh}, index, setIndex}) => {
    const [displayData, SetData] = useState([]);
    const [smallPlots, SetSmallPlots] = useState([]);
    const [smallPlotsIndexes, SetSmallPlotsIndexes] = useState([]);
    const [startingIndex, SetStartingIndex] = useState(0);
    const [endingIndex, SetEndingIndex] = useState(0);

    useEffect(() => {
        if (!hide_data.hasOwnProperty(active_plot) || !plot_data.hasOwnProperty(active_plot))
            return;
        // const filtered = {...Object.keys(plot_data)};


        const filtered = {...Object.keys(plot_data)};
        SetData(calculateData(filtered));
        SetEndingIndex(Object.keys(plot_data).length)

    }, [plot_data, hide_data, active_plot, refresh]);

    useEffect(() => {
        filterForSmallPlots(0, 4)
    }, []);

    const calculateData = (filtered) => {
        for (const [name, value] of Object.entries(plot_data)) {
            if (hide_data.hasOwnProperty(name)) {
                filtered[name] = value.filter(key => !hide_data[name].includes(key.nazwa_regionu));
                const d = new DataView().source(filtered[name]);
                d.transform({
                        type: 'map',
                        callback: obj => {

                            obj.range = [obj.low, obj.q1, obj.median, obj.q3, obj.high];
                            return obj;
                        }
                    }
                )
                filtered[name] = d.rows
            }
        }


        return filtered;
    };


    const filterForSmallPlots = (start, end) => {
        let newSmallPlots = {};
        let newSmallPlotsIndexes = {};
        let keys = Object.keys(plot_data);
        if (end > keys.length) {
            end = keys.length
        }
        if (start < 0) {
            start = 0

        }
        for (let i = start; i < end; i++) {
            newSmallPlots[keys[i]] = plot_data[keys[i]];
            newSmallPlotsIndexes[keys[i]] = i;
        }

        SetSmallPlots(newSmallPlots);
        SetSmallPlotsIndexes(newSmallPlotsIndexes);
    };

    useEffect(() => {
        filterForSmallPlots(startingIndex, startingIndex + 4)


    }, [startingIndex, endingIndex])

    return (<Fragment>{displayData.length !== 0 ?
            <CardGroup className="h-3 p-1">

                {startingIndex !== 0 && <Card as={"a"} style={{cursor: "pointer"}} className="width-10"
                                              onClick={() => SetStartingIndex(startingIndex - 4)}> <span
                    aria-hidden="true" className="carousel-control-prev-icon" style={style_prev}/> </Card>}
                {Object.keys(smallPlots).map((key, i) => <SingleSlidePlot setIndex={setIndex} index={index}
                                                                          id={smallPlotsIndexes[key]}
                                                                          key={i} displayData={displayData} name={key}/>
                )}
                {startingIndex + 4 < Object.keys(plot_data).length &&
                <Card as={"a"} style={{cursor: "pointer"}} onClick={() => SetStartingIndex(startingIndex + 4)}> <span
                    aria-hidden="true" className="carousel-control-next-icon" style={style_next}/> </Card>}
            </CardGroup>

            : <Spinner/>}
            <Card> </Card>
        </Fragment>

    )

};
const style_next = {
    "backgroundImage": `url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' fill='%23000' width='8' height='8' viewBox='0 0 8 8'%3e%3cpath d='M2.75 0l-1.5 1.5L3.75 4l-2.5 2.5L2.75 8l4-4-4-4z'/%3e%3c/svg%3e")`

}

const style_prev = {

    "backgroundImage": `url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%20300' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E")`

}
// export default IndicatorList
const mapStateToProps = state => ({
    PlotData: state.PlotData

});
export default connect(mapStateToProps, null)(PlotCarousel)